import { atom } from 'recoil';

/**
 * 화면 위 검은 화면
 */
export const overlayStore = atom({
  key: 'overlayStore',
  default: false as boolean,
});
